import AbstractMessageHandler from "./abstractmessagehandler";
import { PUB_ACK, UPUI, ERROR_CODE, SUCCESS_CODE } from "../../constant/system";
import UserInfo from "../model/userInfo";

export default class GetUserInfoHandler extends AbstractMessageHandler{
    match(proto){
        return proto.signal == PUB_ACK && proto.subSignal == UPUI;
    }

    notifyContent(content){
        var userInfoList = JSON.parse(content);
        var userInfos = [];
        for(var i in userInfoList){
            userInfos.push(UserInfo.convert2UserInfo(userInfoList[i]));
        }
        this.vueWebsocket.sendAction("updateUserInfos",userInfos);
        return userInfos;
    }
}


// WEBPACK FOOTER //
// ./src/fscommon/websocket/handler/getuserinfoHandler.js